module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-section', {
    attrs: {
      "title": "Support",
      "set-position": "relative",
      "set-width": "100"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "o-content ie p-support",
    attrs: {
      "id": "app"
    }
  }, [_c('icons'), _vm._v(" "), _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin"
  }, [_c('div', {
    staticClass: "flex-grid__g-6 a-form-inputs u-margin-right-60 u-r-no-margin"
  }, [_c('h2', {
    staticClass: "u-r-margin-top-0"
  }, [_vm._v("Have a Query?")]), _vm._v(" "), _c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('label', {
    staticClass: "u-margin-bottom-10 u-d-block",
    attrs: {
      "for": "Claim"
    }
  }, [_vm._v("Claim Reference (optional)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.claimText),
      expression: "claimText"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "text"
    },
    domProps: {
      "value": (_vm.claimText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.claimText = $event.target.value
      }
    }
  }), _c('br'), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "u-margin-bottom-10 u-d-block",
    attrs: {
      "for": "Your Query"
    }
  }, [_vm._v("Your Query")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.queryText),
      expression: "queryText"
    }],
    staticClass: "u-full-width",
    attrs: {
      "name": "",
      "id": "",
      "cols": "30",
      "rows": "8"
    },
    domProps: {
      "value": (_vm.queryText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.queryText = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.sent) ? _c('p', [_vm._v("Your query has been received and we will be in touch soon.")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "a-button",
    on: {
      "click": function($event) {
        return _vm.sendEmail()
      }
    }
  }, [_vm._v("Send Query")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__g-6"
  }, [_c('h2', [_vm._v("Email Support")]), _vm._v(" "), _c('p', [_vm._v("For more detailed assistance, support and handling guidance:")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', {
    staticClass: "u-r-margin-top-40"
  }, [_vm._v("Policies")]), _vm._v(" "), _c('p', {
    staticClass: "u-r-margin-bottom-0"
  }, [_vm._v("To view our policy documents regarding the use of this application just follow the links below:")]), _vm._v(" "), _c('modal-in-the-wild', {
    attrs: {
      "modal-name": "support_cookie_policy"
    }
  }, [_c('p', {
    staticClass: "c-modal-in-the-wild"
  }, [_vm._v("Cookie Policy")])]), _vm._v(" "), _c('span', {
    staticClass: "p-support--divider u-r-margin-bottom-30 u-r-d-inline-block"
  }, [_vm._v("|")]), _vm._v(" "), _c('modal-in-the-wild', {
    attrs: {
      "modal-name": "support_disclaimer"
    }
  }, [_c('p', {
    staticClass: "c-modal-in-the-wild"
  }, [_vm._v("Disclaimer")])]), _vm._v(" "), _c('span', {
    staticClass: "p-support--divider u-r-margin-bottom-30 u-r-d-inline-block"
  }, [_vm._v("|")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "p-support--divider u-r-margin-bottom-30 u-r-d-inline-block"
  }, [_vm._v("|")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('span', {
    staticClass: "p-support--divider u-r-margin-bottom-30 u-r-d-inline-block"
  }, [_vm._v("|")]), _vm._v(" "), _vm._m(3)], 1)]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "support_disclaimer",
      "no-default-button": "true"
    }
  }, [_c('disclaimer')], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "support_cookie_policy",
      "no-default-button": "true"
    }
  }, [_c('cookie-policy')], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "support_privacy_policy",
      "no-default-button": "true"
    }
  }, [_c('privacy-policy')], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "mailto:abcquantum@bc-legal.co.uk"
    }
  }, [_vm._v("abcquantum@bc-legal.co.uk")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://quantum.internal.bc-legal.co.uk/api/v1/licenses/security-policy.pdf",
      "target": "_blank"
    }
  }, [_c('p', {
    staticClass: "c-modal-in-the-wild"
  }, [_vm._v("Security Policy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://quantum.internal.bc-legal.co.uk/api/v1/licenses/privacy-policy.pdf",
      "target": "_blank"
    }
  }, [_c('p', {
    staticClass: "c-modal-in-the-wild"
  }, [_vm._v("Privacy Policy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://quantum.internal.bc-legal.co.uk/api/v1/licenses/license-agreement.pdf",
      "target": "_blank"
    }
  }, [_c('p', {
    staticClass: "c-modal-in-the-wild"
  }, [_vm._v("License Agreement")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-42d3fcad!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/support/Support.vue
// module id = 1664
// module chunks = 0